import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HomeService {

  premissaoItemMenu = new EventEmitter<any>();

  constructor(private httpClient: HttpClient) { }

  permissaoItemMenu(obj: any) {
   this.premissaoItemMenu.emit(obj)
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/home/service/home.service.ts